<div *ngIf="tabs?.length">
	<table class="table" [class.multi-row]="combinedCells.length > 1" [ngClass]="{ bordered: isBordered, padded: isPadded }" [class.zebra-color]="isZebraColor">
		<colgroup *ngIf="columnWidths?.length">
			<ng-container *ngFor="let colWidth of columnWidths">
				<col width="{{ colWidth }}%" />
			</ng-container>
		</colgroup>
		<thead [class.invert-zebra-color]="isZebraColor">
			<tr>
				<th *ngIf="tabs[0].tableData[0]?.firstColumnTitle" class="text-align-left">
					<span class="text-14-bold header-box">
						{{ tabs[0].tableData[0].firstColumnTitle }}
						<dcr-cell-content [cell]="tabs[0].tableData[0].firstColumnTitle"></dcr-cell-content>
					</span>
				</th>
				<ng-container *ngFor="let header of headersX; index as j">
					<th *ngIf="header?.config?.visible" [ngClass]="[header?.attribute?.align ? header.attribute.align : 'text-align-right']">
						<div class="text-14-bold header-box">
							<div>
								<span [forcedLineBreak]="header.formattedValue" [useInlineFlex]="false" class="icon-caption"> </span>
								<ng-container *ngIf="header?.config?.infoBubble?.translated">
									<icon
										type="info-circle"
										class="info-circle text-14 color-primary"
										[tooltip]="infoBubble"
										[analytic-data]="{ linkName: 'tooltip_' + header.config.infoBubble.key }"
									></icon>
								</ng-container>
							</div>
							<dcr-cell-content [cell]="header"></dcr-cell-content>
							<ng-template #infoBubble> <section [innerHTML]="header.config.infoBubble"></section> </ng-template>
						</div>
					</th>
				</ng-container>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let portfolio of headersY; index as j">
				<tr *ngFor="let row of combinedCells; first as first; last as last" [class.start]="first" [class.end]="last" [class.invert-zebra-color]="isZebraColor && !(j % 2)">
					<td
						*ngIf="first && tabs[0].tableData[0]?.firstColumnTitle"
						[class.striped]="isStriped && j > 0"
						[attr.rowspan]="combinedCells.length"
						class="text-align-left first-column"
					>
						<span class="icon-caption" [ngClass]="{ 'sub-category text-sm-14': headersY[j].parent }">{{ headersY[j].formattedValue }}</span>
					</td>
					<ng-container *ngFor="let cell of row[j]; index as i">
						<td
							*ngIf="cell.config?.visible"
							[class.striped]="isStriped && j > 0 && first"
							[ngClass]="headersX[i]?.attribute?.align ? headersX[i].attribute.align : 'text-align-right'"
						>
							<span *ngIf="cell.formattedValue; else notApplicable">
								<ac-table-cell [data]="cell"></ac-table-cell>
							</span>
						</td>
					</ng-container>
				</tr>
			</ng-container>
		</tbody>
	</table>
</div>

<ng-template #notApplicable> <span class="text-align-right" [ngClass]="dataColumnClass">n/a</span> </ng-template>
